import { GET, POST, PUT } from "./_config";

//admin
export const getLoginUserDetails = async () => await GET("/users/me", true);

export const updateLoginUserDataById = async (body) =>
  await PUT(`/users/update-my-profile`, body, true);

export const updateLoginUserPassword = async (body) =>
  await PUT(`/users/update-my-password`, body, true);

export const createUser = async (body) =>
  await POST("/users/add-user", body, true);

export const getUsersDataList = async (query) =>
  await GET(`/users/list?${query || ""}`, true);

export const getUserDataById = async (id) => await GET(`/users/${id}`, true);

export const updateUserDataById = async (id, body) =>
  await PUT(`/users/${id}`, body, true);

export const updateUserStatus = async (body) =>
  await POST("/users/update-status", body, true);

export const deleteUserById = async (body) =>
  await POST(`/users/delete-user`, body, true);

export const updateUserPassword = async (body) =>
  await POST(`/users/update-password`, body, true);
